import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[75vh] flex items-center justify-center bg-black overflow-hidden px-4 py-14 matrix-rain-bg scanlines" data-id="element-83">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black z-0" data-id="element-84" />

      {/* Decorative glowing orb - Matrix green */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-matrix-green/10 rounded-full blur-[120px] pointer-events-none z-0" data-id="element-85" />

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-87">
          {/* Logo */}
          <motion.img src="https://i.postimg.cc/QdbbLnHt/Diseno-sin-titulo-7-removebg-preview.png" alt="PromptAdsPro Logo" className="h-16 md:h-20 w-auto mx-auto mb-6 drop-shadow-[0_0_15px_rgba(0,255,65,0.4)]" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-88" />

          <div className="w-16 h-px bg-gradient-to-r from-transparent via-matrix-green to-transparent mx-auto mb-4 opacity-70" data-id="element-89" />

          <span className="inline-block py-1 px-3 rounded-full bg-matrix-green/15 text-matrix-green font-mono font-bold text-sm tracking-wider mb-4 uppercase border border-matrix-green/30 shadow-[0_0_15px_rgba(0,255,65,0.2)]" data-id="element-90">
            Atención Media Buyers e Infoproductores
          </span>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6 drop-shadow-lg" data-id="element-91">
            Tus creativos se saturan en 3–7 días.{' '}
            <br className="hidden md:block" data-id="element-92" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-matrix-green to-matrix-bright text-glow-green" data-id="element-93">
              Este software te da el sistema
            </span>{' '}
            para sacar el próximo ángulo sin adivinar.
          </h1>

          <p className="font-body text-lg md:text-2xl text-gray-300 max-w-3xl mx-auto mb-8 font-medium leading-relaxed" data-id="element-94">
            (Y sin copy robótico). Software de ingeniería publicitaria con IA:
            Producí 10 variaciones estratégicas en 30 minutos.
          </p>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="relative max-w-3xl mx-auto mb-8 rounded-2xl overflow-hidden border border-matrix-green/30 shadow-[0_0_30px_rgba(0,255,65,0.2)] glow-green-sm" data-id="element-95">
            <div className="absolute inset-0 bg-matrix-green/10 mix-blend-overlay pointer-events-none" data-id="element-96" />
            <img src="https://i.postimg.cc/rwbk9zgR/1.webp" alt="Media buyer frustrado analizando métricas" className="w-full h-auto object-cover" data-id="element-97" />
          </motion.div>

          <p className="mt-4 text-gray-400 text-sm font-body flex items-center justify-center gap-2" data-id="element-98">
            <span className="w-2 h-2 rounded-full bg-matrix-green animate-pulse shadow-[0_0_10px_rgba(0,255,65,0.5)]" data-id="element-99" />
            Acceso inmediato. Sin curva de aprendizaje.
          </p>
        </motion.div>
      </div>
    </section>;
}